function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import MultiExampleHarness from '../../components/MultiExampleHarness/MultiExampleHarness';
export default function MultiExample(props) {
  var content = [];
  var examples = [];
  var index = 0;
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.children.map(function (child) {
    if (child.type === 'h1') {
      examples[index] = {
        label: child.props.children[2]
      };
    } else if (child.type === 'p' && child.props.children.type !== 'img') {
      content.push(child);
      examples[index].content = content;
    } else if (child.type === 'p' && child.props.children.type === 'img') {
      examples[index].image = _extends({}, child.props.children.props);
      index++;
      content = []; // Reset the content array for the next example
    }
  }), /*#__PURE__*/React.createElement(MultiExampleHarness, {
    examples: examples
  }));
}
//# sourceMappingURL=MultiExample.js.map